import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { WeakLink } from '@liveauctioneers/hammer-ui-core/link';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { AdUnit } from '@/redux/modules/catalog/ad/catalogAd.types';
import { addImageParams, getAdQuestionUrl, getSellerUrl } from '@/utils/urls';

type Props = React.PropsWithChildren<{
    adUnit: AdUnit;
    className: string;
    scrolled: boolean;
    stick: boolean;
    stickBottom: boolean;
    trackClick: (event: React.SyntheticEvent) => void;
}>;

export const ConsignmentAd = (props: Props) => {
    const { adUnit, children, className, scrolled, stick, stickBottom, trackClick } = props;
    const { destination, imageUrl1, sellerId = 0, sellerName = '' } = adUnit;

    let style: { [attribute: string]: string | number } =
        stick && scrolled ? { marginLeft: 12.5, marginRight: 12.5, position: 'fixed', top: 0 } : {};
    if (stickBottom && scrolled) {
        style = {
            bottom: 0,
            marginLeft: 12.5,
            marginRight: 12.5,
            position: 'absolute',
        };
    }

    const to = destination || `${getSellerUrl(sellerId, sellerName)}?consign=true`;

    return (
        <div
            className="relative mt-md flex flex-col items-center justify-start"
            onClick={trackClick}
            style={style}
        >
            <div className={cn('h-[643px] w-[182px] border border-border-secondary', className)}>
                <WeakLink href={to}>
                    <img
                        alt={sellerName}
                        className="block"
                        loading="lazy"
                        src={addImageParams({ url: imageUrl1 })}
                    />
                </WeakLink>
            </div>
            <div className="w-[180px]">
                <FormattedMessage id="advertisement" />{' '}
                <WeakLink
                    href={getAdQuestionUrl()}
                    size="xs"
                    target="_blank"
                >
                    <FormattedMessage id="your_ad_here" />
                </WeakLink>
            </div>
            {children}
        </div>
    );
};
